import type { TrainingView } from 'features/courier-training/services/courierTrainingService';

export const hasCompletedAllTrainingVideos = (
  training: TrainingView | null,
): boolean =>
  Boolean(
    training &&
      training.stages.length > 0 &&
      training.stages.every(
        (stage) =>
          stage.videos.length > 0 &&
          stage.videos.every((video) => video.completed),
      ),
  );
